// Copyright (c) StrangeBee 2023

import { useLocalMessage } from '@Helpers/';
import { WIDGET_DND_TYPES } from '@Types';
import React, { ReactElement, useRef, ReactNode } from 'react';
import { useDrop } from 'react-dnd';
import EmptyElement from '@Organisms/Dashboard/DashboardDetails/EmptyElementToDrop/EmptyElementToDrop';

import './DropableWidgetRowList.scss';

interface DroppableNewRowProps {
    children: ReactNode;
}

const DropableWidgetRowList = ({ children }: DroppableNewRowProps): ReactElement => {
    const i = useLocalMessage();
    const ref = useRef(null);

    const [{ isHovered, isOverCurrent }, drop] = useDrop({
        accept: WIDGET_DND_TYPES.ROW,
        collect: (monitor) => ({
            isHovered: monitor.isOver(),
            isOverCurrent: monitor.isOver({ shallow: true }),
        }),
    });

    drop(ref);

    const shouldDisplayEmptyBlock = isHovered && isOverCurrent;

    return (
        <div ref={ref} className="dropable-widget-row-list">
            {children}
            {shouldDisplayEmptyBlock && <EmptyElement text={i('dashboard.drop.row')} />}
        </div>
    );
};

export default DropableWidgetRowList;
